export const SET_GENERAL = "SET_GENERAL";

export function setGeneral(payload: Partial<GeneralState>) {
    return { type: SET_GENERAL, payload };
}

export type GeneralState = {

}

const initialState: GeneralState = {
};

export default function (state = initialState, action: any) {
    switch (action.type) {
        case SET_GENERAL:
            return {
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}